
const ArrowDownIcon = () => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" className="st0" width="22" viewBox="0 0 22 22.001" style={{marginTop:3}}>
        <g className="st0">
	<path className="st1" d="M16.5,6.3l-4.9,4.9c-0.1,0.1-0.3,0.1-0.4,0L6.3,6.3C6.1,6.2,6.1,6,6.3,5.9l0.2-0.2c0.1-0.1,0.3-0.1,0.4,0
		l4.6,4.6L16,5.8c0.1-0.1,0.3-0.1,0.4,0l0.2,0.2C16.7,6,16.7,6.2,16.5,6.3z"/>
</g>
</svg>
  );
}
export default ArrowDownIcon;
